import I18n from 'I18n';
import { fromJS } from 'immutable';
export const useSampleDatawellVisualizations = templateKey => {
  const {
    text
  } = I18n;
  const sampleDatawellVisualizationsByTemplateKey = {
    'commerce-analytics.count-churn-subscriptions': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            'SUM|hs_arr_in_company_currency': 52716,
            __home_currency_code__: 'USD'
          }],
          properties: {
            'SUM|hs_arr_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumAnnualRecurringRevenueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_arr_in_company_currency',
              references: {
                'USD|52716': {
                  id: 'USD|52716',
                  label: '$52,716.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            }
          }
        }
      },
      layer: {
        compact: true,
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|hs_arr_in_company_currency'],
        direction: 'horizontal'
      },
      events: {}
    }),
    'commerce-analytics.churn-subscriptions': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            __home_currency_code__: 'USD',
            'SUM|hs_arr_in_company_currency': 52716
          }],
          properties: {
            'SUM|hs_arr_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumAnnualRecurringRevenueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_arr_in_company_currency',
              references: {
                'USD|52716': {
                  id: 'USD|52716',
                  label: '$52,716.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            }
          }
        }
      },
      layer: {
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|hs_arr_in_company_currency'],
        direction: 'horizontal'
      },
      events: {}
    }),
    'commerce-analytics.count-new-subscriptions': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            'SUM|count': 190
          }],
          properties: {
            'SUM|count': {
              format: {
                type: 'number',
                isFormatted: true
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.countOfSubscriptions'),
              type: 'number',
              name: 'count',
              references: {
                '190': {
                  id: '190',
                  label: '190'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          }
        }
      },
      layer: {
        compact: true,
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|count'],
        direction: 'horizontal'
      },
      events: {}
    }),
    'commerce-analytics.aging-summary': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            'SUM|count': 48
          }],
          properties: {
            'SUM|count': {
              format: {
                type: 'number',
                isFormatted: true
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.countOfInvoices'),
              type: 'number',
              name: 'count',
              references: {
                '48': {
                  id: '48',
                  label: '48'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          },
          paginationSize: 1
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layer: {
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|count'],
        direction: 'horizontal'
      },
      events: {}
    }),
    'commerce-analytics.balance-due-by-billing-type': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            __home_currency_code__: 'USD',
            'SUM|hs_balance_due_in_company_currency': 81274,
            hs_billing_frequency_type: 'ONE_TIME'
          }],
          properties: {
            hs_billing_frequency_type: {
              format: {
                type: 'enumeration',
                options: {
                  ONE_TIME: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.oneTime'),
                    displayOrder: 1
                  },
                  RECURRING: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.recurring'),
                    displayOrder: 2
                  }
                }
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.billingFrequencyType'),
              type: 'enumeration',
              name: 'hs_billing_frequency_type',
              references: {
                ONE_TIME: {
                  id: 'ONE_TIME',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.oneTime')
                }
              }
            },
            'SUM|hs_balance_due_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumBalanceDueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_balance_due_in_company_currency',
              references: {
                'USD|81274': {
                  id: 'USD|81274',
                  label: '$81,274.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            }
          },
          paginationSize: 2
        }
      },
      layer: {
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|hs_balance_due_in_company_currency'],
        group: 'hs_billing_frequency_type',
        direction: 'vertical'
      },
      events: {}
    }),
    'commerce-analytics.expected-vs-actual-revenue': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            __home_currency_code__: 'USD',
            'SUM|hs_amount_billed_in_company_currency': 179495.4
          }],
          properties: {
            'SUM|hs_amount_billed_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumAmountBilledInCompanyCurrency'),
              type: 'currency',
              name: 'hs_amount_billed_in_company_currency',
              references: {
                'USD|179495.4': {
                  id: 'USD|179495.4',
                  label: '$179,495.40'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            }
          }
        }
      },
      layer: {
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|hs_amount_billed_in_company_currency'],
        direction: 'horizontal'
      },
      events: {}
    }),
    'commerce-analytics.invoice-status': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            'SUM|count': 336
          }],
          properties: {
            'SUM|count': {
              format: {
                type: 'number',
                isFormatted: true
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.countOfInvoices'),
              type: 'number',
              name: 'count',
              references: {
                '336': {
                  id: '336',
                  label: '336'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layer: {
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|count'],
        direction: 'horizontal'
      },
      events: {}
    }),
    'commerce-analytics.new-subscriptions': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            __home_currency_code__: 'USD',
            'SUM|hs_arr_in_company_currency': 83050
          }],
          properties: {
            'SUM|hs_arr_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumAnnualRecurringRevenueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_arr_in_company_currency',
              references: {
                'USD|83050': {
                  id: 'USD|83050',
                  label: '$83,050.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            }
          }
        }
      },
      layer: {
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|hs_arr_in_company_currency'],
        direction: 'horizontal'
      },
      events: {}
    }),
    'commerce-analytics.gross-payment-revenue': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            hs_payment_type: 'one_time_or_initial',
            __home_currency_code__: 'USD',
            'SUM|hs_initial_amount_in_portal_currency': 39160
          }],
          properties: {
            hs_payment_type: {
              format: {
                type: 'enumeration',
                options: {
                  one_time_or_initial: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.oneTimeInitial'),
                    displayOrder: 0
                  },
                  recurring: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.recurring'),
                    displayOrder: 1
                  }
                }
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.paymentType'),
              type: 'enumeration',
              name: 'hs_payment_type',
              references: {
                one_time_or_initial: {
                  id: 'one_time_or_initial',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.oneTimeInitial')
                }
              }
            },
            'SUM|hs_initial_amount_in_portal_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumGrossAmountInCompanyCurrency'),
              type: 'currency',
              name: 'hs_initial_amount_in_portal_currency',
              references: {
                'USD|39160': {
                  id: 'USD|39160',
                  label: '$39,160.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            }
          },
          paginationSize: 2
        }
      },
      layer: {
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|hs_initial_amount_in_portal_currency'],
        group: 'hs_payment_type',
        direction: 'vertical'
      },
      events: {}
    }),
    'commerce-analytics.total-payment-volume': fromJS({
      type: 'DATAWELL',
      data: {
        primary: {
          data: [{
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 1257753.48
          }],
          properties: {
            'SUM|hs_initial_amount': {
              format: {
                type: 'currency',
                currencyCodeColumnName: 'hs_currency_code',
                currencyCode: null
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumGrossAmount'),
              type: 'currency',
              name: 'hs_initial_amount',
              references: {
                '1257753.48': {
                  id: '1257753.48',
                  label: '1,257,753.48'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            hs_currency_code: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: 'hs_currency_code',
              type: 'enumeration',
              name: 'hs_currency_code',
              references: {
                '@@MISSING@@': {
                  id: '@@MISSING@@',
                  label: '@@MISSING@@'
                }
              }
            }
          }
        }
      },
      layer: {
        valueFormattingOptions: [],
        subtitleColumnMap: {},
        dataset: 'primary',
        fields: ['SUM|hs_initial_amount'],
        direction: 'horizontal'
      },
      events: {}
    })
  };
  return sampleDatawellVisualizationsByTemplateKey[templateKey];
};
export const useSampleChartVisualizations = templateKey => {
  const {
    text
  } = I18n;
  const sampleChartVisualizationsByTemplateKey = {
    'commerce-analytics.aging-summary': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            'SUM|count': 8,
            hs_invoice_age_category: '@@MISSING@@'
          }, {
            'SUM|count': 14,
            hs_invoice_age_category: 'zero_days'
          }, {
            'SUM|count': 22,
            hs_invoice_age_category: 'between_1_30_days'
          }, {
            'SUM|count': 12,
            hs_invoice_age_category: 'between_31_60_days'
          }],
          properties: {
            hs_invoice_age_category: {
              format: {
                type: 'enumeration',
                options: {
                  zero_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.current'),
                    displayOrder: 0
                  },
                  between_1_30_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between130Days'),
                    displayOrder: 1
                  },
                  between_31_60_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between3160Days'),
                    displayOrder: 2
                  },
                  between_61_90_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between6190Days'),
                    displayOrder: 3
                  },
                  over_90_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.over90Days'),
                    displayOrder: 4
                  }
                }
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.ageCategory'),
              type: 'enumeration',
              name: 'hs_invoice_age_category',
              references: {
                '@@MISSING@@': {
                  id: '@@MISSING@@',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.noValue')
                },
                zero_days: {
                  id: 'zero_days',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.current')
                },
                between_1_30_days: {
                  id: 'between_1_30_days',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between130Days')
                },
                between_31_60_days: {
                  id: 'between_31_60_days',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between3160Days')
                }
              }
            },
            'SUM|count': {
              format: {
                type: 'number',
                isFormatted: true
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.countOfInvoices'),
              type: 'number',
              name: 'count',
              references: {
                '8': {
                  id: '8',
                  label: '8'
                },
                '12': {
                  id: '12',
                  label: '12'
                },
                '14': {
                  id: '14',
                  label: '14'
                },
                '22': {
                  id: '22',
                  label: '22'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          },
          paginationSize: 4
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            'SUM|count': '#fea58e'
          }
        },
        x: {
          type: 'category',
          field: 'hs_invoice_age_category',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|count',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {}
        },
        dateResolution: 'WEEK',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.balance-due-by-billing-type': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            'SUM|count': 9,
            hs_invoice_age_category: '@@MISSING@@'
          }, {
            'SUM|count': 15,
            hs_invoice_age_category: 'zero_days'
          }, {
            'SUM|count': 24,
            hs_invoice_age_category: 'between_1_30_days'
          }, {
            'SUM|count': 13,
            hs_invoice_age_category: 'between_31_60_days'
          }],
          properties: {
            hs_invoice_age_category: {
              format: {
                type: 'enumeration',
                options: {
                  zero_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.current'),
                    displayOrder: 0
                  },
                  between_1_30_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between130Days'),
                    displayOrder: 1
                  },
                  between_31_60_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between3160Days'),
                    displayOrder: 2
                  },
                  between_61_90_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between6190Days'),
                    displayOrder: 3
                  },
                  over_90_days: {
                    label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.over90Days'),
                    displayOrder: 4
                  }
                }
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.ageCategory'),
              type: 'enumeration',
              name: 'hs_invoice_age_category',
              references: {
                '@@MISSING@@': {
                  id: '@@MISSING@@',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.noValue')
                },
                zero_days: {
                  id: 'zero_days',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.current')
                },
                between_1_30_days: {
                  id: 'between_1_30_days',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between130Days')
                },
                between_31_60_days: {
                  id: 'between_31_60_days',
                  label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.between3160Days')
                }
              }
            },
            'SUM|count': {
              format: {
                type: 'number',
                isFormatted: true
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.countOfInvoices'),
              type: 'number',
              name: 'count',
              references: {
                '9': {
                  id: '9',
                  label: '9'
                },
                '13': {
                  id: '13',
                  label: '13'
                },
                '15': {
                  id: '15',
                  label: '15'
                },
                '24': {
                  id: '24',
                  label: '24'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          },
          paginationSize: 4
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            'SUM|count': '#fea58e'
          }
        },
        x: {
          type: 'category',
          field: 'hs_invoice_age_category',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|count',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {}
        },
        dateResolution: 'WEEK',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.expected-vs-actual-revenue': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-01',
            'SUM|hs_balance_due_in_company_currency': 1250,
            hs_billing_frequency_type: 'ONE_TIME'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-02',
            'SUM|hs_balance_due_in_company_currency': 2200,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-06',
            'SUM|hs_balance_due_in_company_currency': 1000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-08',
            'SUM|hs_balance_due_in_company_currency': 2000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-09',
            'SUM|hs_balance_due_in_company_currency': 2000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-12',
            'SUM|hs_balance_due_in_company_currency': 2000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-13',
            'SUM|hs_balance_due_in_company_currency': 1128,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-14',
            'SUM|hs_balance_due_in_company_currency': 233,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-17',
            'SUM|hs_balance_due_in_company_currency': 3000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-23',
            'SUM|hs_balance_due_in_company_currency': 1000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-24',
            'SUM|hs_balance_due_in_company_currency': 3000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-26',
            'SUM|hs_balance_due_in_company_currency': 900,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-27',
            'SUM|hs_balance_due_in_company_currency': 3000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-28',
            'SUM|hs_balance_due_in_company_currency': 1000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-04-30',
            'SUM|hs_balance_due_in_company_currency': 200,
            hs_billing_frequency_type: 'ONE_TIME'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-05-02',
            'SUM|hs_balance_due_in_company_currency': 200,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-05-04',
            'SUM|hs_balance_due_in_company_currency': 1000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-05-06',
            'SUM|hs_balance_due_in_company_currency': 1000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-05-07',
            'SUM|hs_balance_due_in_company_currency': 450,
            hs_billing_frequency_type: 'ONE_TIME'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-05-13',
            'SUM|hs_balance_due_in_company_currency': 1000,
            hs_billing_frequency_type: 'RECURRING'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-05-31',
            'SUM|hs_balance_due_in_company_currency': 5000,
            hs_billing_frequency_type: 'ONE_TIME'
          }, {
            __home_currency_code__: 'USD',
            hs_due_date: '2025-08-03',
            'SUM|hs_balance_due_in_company_currency': 3000,
            hs_billing_frequency_type: 'ONE_TIME'
          }],
          properties: {
            hs_due_date: {
              format: {
                type: 'datetime',
                frequency: 'DAY'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.dueDate'),
              type: 'datetime',
              name: 'hs_due_date',
              references: {
                '2025-07-28': {
                  id: '2025-07-28',
                  label: '7/28/2025'
                },
                '2025-04-03': {
                  id: '2025-04-03',
                  label: '4/3/2025'
                },
                '2025-04-14': {
                  id: '2025-04-14',
                  label: '4/14/2025'
                },
                '2025-04-25': {
                  id: '2025-04-25',
                  label: '4/25/2025'
                },
                '2025-05-04': {
                  id: '2025-05-04',
                  label: '5/4/2025'
                },
                '2025-05-15': {
                  id: '2025-05-15',
                  label: '5/15/2025'
                },
                '2025-05-26': {
                  id: '2025-05-26',
                  label: '5/26/2025'
                },
                '2025-06-05': {
                  id: '2025-06-05',
                  label: '6/5/2025'
                },
                '2025-06-16': {
                  id: '2025-06-16',
                  label: '6/16/2025'
                },
                '2025-06-27': {
                  id: '2025-06-27',
                  label: '6/27/2025'
                },
                '2025-07-06': {
                  id: '2025-07-06',
                  label: '7/6/2025'
                },
                '2025-07-17': {
                  id: '2025-07-17',
                  label: '7/17/2025'
                },
                '2025-07-29': {
                  id: '2025-07-29',
                  label: '7/29/2025'
                },
                '2025-04-04': {
                  id: '2025-04-04',
                  label: '4/4/2025'
                },
                '2025-04-15': {
                  id: '2025-04-15',
                  label: '4/15/2025'
                },
                '2025-04-26': {
                  id: '2025-04-26',
                  label: '4/26/2025'
                },
                '2025-05-05': {
                  id: '2025-05-05',
                  label: '5/5/2025'
                },
                '2025-05-16': {
                  id: '2025-05-16',
                  label: '5/16/2025'
                },
                '2025-05-27': {
                  id: '2025-05-27',
                  label: '5/27/2025'
                },
                '2025-06-06': {
                  id: '2025-06-06',
                  label: '6/6/2025'
                },
                '2025-06-17': {
                  id: '2025-06-17',
                  label: '6/17/2025'
                },
                '2025-06-28': {
                  id: '2025-06-28',
                  label: '6/28/2025'
                },
                '2025-07-07': {
                  id: '2025-07-07',
                  label: '7/7/2025'
                },
                '2025-07-18': {
                  id: '2025-07-18',
                  label: '7/18/2025'
                },
                '2025-04-05': {
                  id: '2025-04-05',
                  label: '4/5/2025'
                },
                '2025-04-16': {
                  id: '2025-04-16',
                  label: '4/16/2025'
                },
                '2025-04-27': {
                  id: '2025-04-27',
                  label: '4/27/2025'
                },
                '2025-05-06': {
                  id: '2025-05-06',
                  label: '5/6/2025'
                },
                '2025-05-17': {
                  id: '2025-05-17',
                  label: '5/17/2025'
                },
                '2025-05-28': {
                  id: '2025-05-28',
                  label: '5/28/2025'
                },
                '2025-06-07': {
                  id: '2025-06-07',
                  label: '6/7/2025'
                },
                '2025-06-18': {
                  id: '2025-06-18',
                  label: '6/18/2025'
                },
                '2025-06-29': {
                  id: '2025-06-29',
                  label: '6/29/2025'
                },
                '2025-07-08': {
                  id: '2025-07-08',
                  label: '7/8/2025'
                },
                '2025-07-19': {
                  id: '2025-07-19',
                  label: '7/19/2025'
                },
                '2025-04-06': {
                  id: '2025-04-06',
                  label: '4/6/2025'
                },
                '2025-04-17': {
                  id: '2025-04-17',
                  label: '4/17/2025'
                },
                '2025-04-28': {
                  id: '2025-04-28',
                  label: '4/28/2025'
                },
                '2025-05-07': {
                  id: '2025-05-07',
                  label: '5/7/2025'
                },
                '2025-05-18': {
                  id: '2025-05-18',
                  label: '5/18/2025'
                },
                '2025-05-29': {
                  id: '2025-05-29',
                  label: '5/29/2025'
                },
                '2025-06-08': {
                  id: '2025-06-08',
                  label: '6/8/2025'
                },
                '2025-06-19': {
                  id: '2025-06-19',
                  label: '6/19/2025'
                },
                '2025-07-09': {
                  id: '2025-07-09',
                  label: '7/9/2025'
                },
                '2025-04-07': {
                  id: '2025-04-07',
                  label: '4/7/2025'
                },
                '2025-04-18': {
                  id: '2025-04-18',
                  label: '4/18/2025'
                },
                '2025-04-29': {
                  id: '2025-04-29',
                  label: '4/29/2025'
                },
                '2025-05-08': {
                  id: '2025-05-08',
                  label: '5/8/2025'
                },
                '2025-05-19': {
                  id: '2025-05-19',
                  label: '5/19/2025'
                },
                '2025-06-09': {
                  id: '2025-06-09',
                  label: '6/9/2025'
                },
                '2025-04-08': {
                  id: '2025-04-08',
                  label: '4/8/2025'
                },
                '2025-04-19': {
                  id: '2025-04-19',
                  label: '4/19/2025'
                },
                '2025-05-09': {
                  id: '2025-05-09',
                  label: '5/9/2025'
                },
                '2025-04-09': {
                  id: '2025-04-09',
                  label: '4/9/2025'
                },
                '2025-07-30': {
                  id: '2025-07-30',
                  label: '7/30/2025'
                },
                '2025-07-31': {
                  id: '2025-07-31',
                  label: '7/31/2025'
                },
                '2025-06-30': {
                  id: '2025-06-30',
                  label: '6/30/2025'
                },
                '2025-07-20': {
                  id: '2025-07-20',
                  label: '7/20/2025'
                },
                '2025-05-30': {
                  id: '2025-05-30',
                  label: '5/30/2025'
                },
                '2025-06-20': {
                  id: '2025-06-20',
                  label: '6/20/2025'
                },
                '2025-07-10': {
                  id: '2025-07-10',
                  label: '7/10/2025'
                },
                '2025-07-21': {
                  id: '2025-07-21',
                  label: '7/21/2025'
                },
                '2025-08-01': {
                  id: '2025-08-01',
                  label: '8/1/2025'
                },
                '2025-04-30': {
                  id: '2025-04-30',
                  label: '4/30/2025'
                },
                '2025-05-20': {
                  id: '2025-05-20',
                  label: '5/20/2025'
                },
                '2025-05-31': {
                  id: '2025-05-31',
                  label: '5/31/2025'
                },
                '2025-06-10': {
                  id: '2025-06-10',
                  label: '6/10/2025'
                },
                '2025-06-21': {
                  id: '2025-06-21',
                  label: '6/21/2025'
                },
                '2025-07-11': {
                  id: '2025-07-11',
                  label: '7/11/2025'
                },
                '2025-07-22': {
                  id: '2025-07-22',
                  label: '7/22/2025'
                },
                '2025-08-02': {
                  id: '2025-08-02',
                  label: '8/2/2025'
                },
                '2025-04-20': {
                  id: '2025-04-20',
                  label: '4/20/2025'
                },
                '2025-05-10': {
                  id: '2025-05-10',
                  label: '5/10/2025'
                },
                '2025-05-21': {
                  id: '2025-05-21',
                  label: '5/21/2025'
                },
                '2025-06-11': {
                  id: '2025-06-11',
                  label: '6/11/2025'
                },
                '2025-06-22': {
                  id: '2025-06-22',
                  label: '6/22/2025'
                },
                '2025-07-01': {
                  id: '2025-07-01',
                  label: '7/1/2025'
                },
                '2025-07-12': {
                  id: '2025-07-12',
                  label: '7/12/2025'
                },
                '2025-07-23': {
                  id: '2025-07-23',
                  label: '7/23/2025'
                },
                '2025-08-03': {
                  id: '2025-08-03',
                  label: '8/3/2025'
                },
                '2025-04-10': {
                  id: '2025-04-10',
                  label: '4/10/2025'
                },
                '2025-04-21': {
                  id: '2025-04-21',
                  label: '4/21/2025'
                },
                '2025-05-11': {
                  id: '2025-05-11',
                  label: '5/11/2025'
                },
                '2025-05-22': {
                  id: '2025-05-22',
                  label: '5/22/2025'
                },
                '2025-06-01': {
                  id: '2025-06-01',
                  label: '6/1/2025'
                },
                '2025-06-12': {
                  id: '2025-06-12',
                  label: '6/12/2025'
                },
                '2025-06-23': {
                  id: '2025-06-23',
                  label: '6/23/2025'
                },
                '2025-07-02': {
                  id: '2025-07-02',
                  label: '7/2/2025'
                },
                '2025-07-13': {
                  id: '2025-07-13',
                  label: '7/13/2025'
                },
                '2025-07-24': {
                  id: '2025-07-24',
                  label: '7/24/2025'
                },
                '2025-04-11': {
                  id: '2025-04-11',
                  label: '4/11/2025'
                },
                '2025-04-22': {
                  id: '2025-04-22',
                  label: '4/22/2025'
                },
                '2025-05-01': {
                  id: '2025-05-01',
                  label: '5/1/2025'
                },
                '2025-05-12': {
                  id: '2025-05-12',
                  label: '5/12/2025'
                },
                '2025-05-23': {
                  id: '2025-05-23',
                  label: '5/23/2025'
                },
                '2025-06-02': {
                  id: '2025-06-02',
                  label: '6/2/2025'
                },
                '2025-06-13': {
                  id: '2025-06-13',
                  label: '6/13/2025'
                },
                '2025-06-24': {
                  id: '2025-06-24',
                  label: '6/24/2025'
                },
                '2025-07-03': {
                  id: '2025-07-03',
                  label: '7/3/2025'
                },
                '2025-07-14': {
                  id: '2025-07-14',
                  label: '7/14/2025'
                },
                '2025-07-25': {
                  id: '2025-07-25',
                  label: '7/25/2025'
                },
                '2025-04-01': {
                  id: '2025-04-01',
                  label: '4/1/2025'
                },
                '2025-04-12': {
                  id: '2025-04-12',
                  label: '4/12/2025'
                },
                '2025-04-23': {
                  id: '2025-04-23',
                  label: '4/23/2025'
                },
                '2025-05-02': {
                  id: '2025-05-02',
                  label: '5/2/2025'
                },
                '2025-05-13': {
                  id: '2025-05-13',
                  label: '5/13/2025'
                },
                '2025-05-24': {
                  id: '2025-05-24',
                  label: '5/24/2025'
                },
                '2025-06-03': {
                  id: '2025-06-03',
                  label: '6/3/2025'
                },
                '2025-06-14': {
                  id: '2025-06-14',
                  label: '6/14/2025'
                },
                '2025-06-25': {
                  id: '2025-06-25',
                  label: '6/25/2025'
                },
                '2025-07-04': {
                  id: '2025-07-04',
                  label: '7/4/2025'
                },
                '2025-07-15': {
                  id: '2025-07-15',
                  label: '7/15/2025'
                },
                '2025-07-26': {
                  id: '2025-07-26',
                  label: '7/26/2025'
                },
                '2025-04-02': {
                  id: '2025-04-02',
                  label: '4/2/2025'
                },
                '2025-04-13': {
                  id: '2025-04-13',
                  label: '4/13/2025'
                },
                '2025-04-24': {
                  id: '2025-04-24',
                  label: '4/24/2025'
                },
                '2025-05-03': {
                  id: '2025-05-03',
                  label: '5/3/2025'
                },
                '2025-05-14': {
                  id: '2025-05-14',
                  label: '5/14/2025'
                },
                '2025-05-25': {
                  id: '2025-05-25',
                  label: '5/25/2025'
                },
                '2025-06-04': {
                  id: '2025-06-04',
                  label: '6/4/2025'
                },
                '2025-06-15': {
                  id: '2025-06-15',
                  label: '6/15/2025'
                },
                '2025-06-26': {
                  id: '2025-06-26',
                  label: '6/26/2025'
                },
                '2025-07-05': {
                  id: '2025-07-05',
                  label: '7/5/2025'
                },
                '2025-07-16': {
                  id: '2025-07-16',
                  label: '7/16/2025'
                },
                '2025-07-27': {
                  id: '2025-07-27',
                  label: '7/27/2025'
                }
              }
            },
            hs_billing_frequency_type: {
              format: {
                type: 'enumeration',
                options: {
                  ONE_TIME: {
                    label: 'One-time',
                    displayOrder: 1
                  },
                  RECURRING: {
                    label: 'Recurring',
                    displayOrder: 2
                  }
                }
              },
              label: 'Billing frequency type',
              type: 'enumeration',
              name: 'hs_billing_frequency_type',
              references: {
                ONE_TIME: {
                  id: 'ONE_TIME',
                  label: 'One-time'
                },
                RECURRING: {
                  id: 'RECURRING',
                  label: 'Recurring'
                }
              }
            },
            'SUM|hs_balance_due_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumBalanceDueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_balance_due_in_company_currency',
              references: {
                'USD|900': {
                  id: 'USD|900',
                  label: '$900.00'
                },
                'USD|8000': {
                  id: 'USD|8000',
                  label: '$8,000.00'
                },
                'USD|7000': {
                  id: 'USD|7000',
                  label: '$7,000.00'
                },
                'USD|5000': {
                  id: 'USD|5000',
                  label: '$5,000.00'
                },
                'USD|3000': {
                  id: 'USD|3000',
                  label: '$3,000.00'
                },
                'USD|9000.4': {
                  id: 'USD|9000.4',
                  label: '$9,000.40'
                },
                'USD|2000': {
                  id: 'USD|2000',
                  label: '$2,000.00'
                },
                'USD|1000': {
                  id: 'USD|1000',
                  label: '$1,000.00'
                },
                'USD|2200': {
                  id: 'USD|2200',
                  label: '$2,200.00'
                },
                'USD|24': {
                  id: 'USD|24',
                  label: '$24.00'
                },
                'USD|14100': {
                  id: 'USD|14100',
                  label: '$14,100.00'
                },
                'USD|450': {
                  id: 'USD|450',
                  label: '$450.00'
                },
                'USD|0': {
                  id: 'USD|0',
                  label: '$0.00'
                },
                'USD|1128': {
                  id: 'USD|1128',
                  label: '$1,128.00'
                },
                'USD|200': {
                  id: 'USD|200',
                  label: '$200.00'
                },
                'USD|233': {
                  id: 'USD|233',
                  label: '$233.00'
                },
                'USD|2800': {
                  id: 'USD|2800',
                  label: '$2,800.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            ONE_TIME: '#99acc2',
            RECURRING: '#cbd6e2'
          },
          field: 'hs_billing_frequency_type'
        },
        x: {
          type: 'category',
          field: 'hs_due_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|hs_balance_due_in_company_currency',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {}
        },
        dateResolution: 'DAY',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.invoice-status': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            hs_invoice_date: '2025-04-01',
            'SUM|hs_amount_paid_in_company_currency': 37460,
            __home_currency_code__: 'USD',
            'SUM|hs_amount_billed_in_company_currency': 96845.4
          }, {
            hs_invoice_date: '2025-05-01',
            'SUM|hs_amount_paid_in_company_currency': 54900,
            __home_currency_code__: 'USD',
            'SUM|hs_amount_billed_in_company_currency': 83050
          }],
          properties: {
            hs_invoice_date: {
              format: {
                type: 'datetime',
                frequency: 'MONTH'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.invoiceDate'),
              type: 'datetime',
              name: 'hs_invoice_date',
              references: {
                '2025-04-01': {
                  id: '2025-04-01',
                  label: 'Apr 2025'
                },
                '2025-05-01': {
                  id: '2025-05-01',
                  label: 'May 2025'
                }
              }
            },
            'SUM|hs_amount_billed_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumAmountBilledInCompanyCurrency'),
              type: 'currency',
              name: 'hs_amount_billed_in_company_currency',
              references: {
                'USD|96845.4': {
                  id: 'USD|96845.4',
                  label: '$96,845.40'
                },
                'USD|83050': {
                  id: 'USD|83050',
                  label: '$83,050.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            },
            'SUM|hs_amount_paid_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumAmountPaidInCompanyCurrency'),
              type: 'currency',
              name: 'hs_amount_paid_in_company_currency',
              references: {
                'USD|37460': {
                  id: 'USD|37460',
                  label: '$37,460.00'
                },
                'USD|54900': {
                  id: 'USD|54900',
                  label: '$54,900.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            'SUM|hs_amount_billed_in_company_currency': '#fea58e',
            'SUM|hs_amount_paid_in_company_currency': '#51d3d9'
          }
        },
        x: {
          type: 'category',
          field: 'hs_invoice_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|hs_amount_billed_in_company_currency',
          blend: 'left'
        }
      }, {
        color: {
          defined: {
            'SUM|hs_amount_billed_in_company_currency': '#fea58e',
            'SUM|hs_amount_paid_in_company_currency': '#51d3d9'
          }
        },
        x: {
          type: 'category',
          field: 'hs_invoice_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|hs_amount_paid_in_company_currency',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {
            title: ''
          }
        },
        dateResolution: 'MONTH',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.new-subscriptions': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            __home_currency_code__: 'USD',
            hs_recurring_billing_start_date: '2025-04-01',
            'SUM|hs_mrr_in_company_currency': 4393,
            'SUM|hs_arr_in_company_currency': 52716
          }, {
            __home_currency_code__: 'USD',
            hs_recurring_billing_start_date: '2025-05-01',
            'SUM|hs_mrr_in_company_currency': 6755,
            'SUM|hs_arr_in_company_currency': 83050
          }],
          properties: {
            hs_recurring_billing_start_date: {
              format: {
                type: 'date',
                frequency: 'MONTH'
              },
              label: 'Start date',
              type: 'date',
              name: 'hs_recurring_billing_start_date',
              references: {
                '2025-04-01': {
                  id: '2025-04-01',
                  label: 'Apr 2025'
                },
                '2025-05-01': {
                  id: '2025-05-01',
                  label: 'May 2025'
                }
              }
            },
            'SUM|hs_arr_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumAnnualRecurringRevenueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_arr_in_company_currency',
              references: {
                'USD|52716': {
                  id: 'USD|52716',
                  label: '$52,716.00'
                },
                'USD|0': {
                  id: 'USD|0',
                  label: '$0.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            },
            'SUM|hs_mrr_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumMonthlyRecurringRevenueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_mrr_in_company_currency',
              references: {
                'USD|4393': {
                  id: 'USD|4393',
                  label: '$4,393.00'
                },
                'USD|0': {
                  id: 'USD|0',
                  label: '$0.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            'SUM|hs_arr_in_company_currency': '#fea58e',
            'SUM|hs_mrr_in_company_currency': '#51d3d9'
          }
        },
        x: {
          type: 'category',
          field: 'hs_recurring_billing_start_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|hs_arr_in_company_currency',
          blend: 'left'
        }
      }, {
        color: {
          defined: {
            'SUM|hs_arr_in_company_currency': '#fea58e',
            'SUM|hs_mrr_in_company_currency': '#51d3d9'
          }
        },
        x: {
          type: 'category',
          field: 'hs_recurring_billing_start_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|hs_mrr_in_company_currency',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {
            title: ''
          }
        },
        dateResolution: 'MONTH',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.gross-payment-revenue': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            hs_initiated_date: '2025-04-01',
            __home_currency_code__: 'USD',
            hs_payment_type: 'one_time_or_initial',
            'SUM|hs_initial_amount_in_portal_currency': 28750
          }, {
            hs_initiated_date: '2025-04-01',
            __home_currency_code__: 'USD',
            hs_payment_type: 'recurring',
            'SUM|hs_initial_amount_in_portal_currency': 14280
          }, {
            hs_initiated_date: '2025-05-01',
            __home_currency_code__: 'USD',
            hs_payment_type: 'one_time_or_initial',
            'SUM|hs_initial_amount_in_portal_currency': 16340
          }, {
            hs_initiated_date: '2025-05-01',
            __home_currency_code__: 'USD',
            hs_payment_type: 'recurring',
            'SUM|hs_initial_amount_in_portal_currency': 7875
          }],
          properties: {
            hs_initiated_date: {
              format: {
                type: 'datetime',
                frequency: 'MONTH'
              },
              label: 'Payment date',
              type: 'datetime',
              name: 'hs_initiated_date',
              references: {
                '2025-04-01': {
                  id: '2025-04-01',
                  label: 'Apr 2025'
                },
                '2025-05-01': {
                  id: '2025-05-01',
                  label: 'May 2025'
                }
              }
            },
            hs_payment_type: {
              format: {
                type: 'enumeration',
                options: {
                  one_time_or_initial: {
                    label: 'One-Time/Initial',
                    displayOrder: 0
                  },
                  recurring: {
                    label: 'Recurring',
                    displayOrder: 1
                  }
                }
              },
              label: 'Payment type',
              type: 'enumeration',
              name: 'hs_payment_type',
              references: {
                one_time_or_initial: {
                  id: 'one_time_or_initial',
                  label: 'One-Time/Initial'
                },
                recurring: {
                  id: 'recurring',
                  label: 'Recurring'
                }
              }
            },
            'SUM|hs_initial_amount_in_portal_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: 'Sum Gross amount in company currency',
              type: 'currency',
              name: 'hs_initial_amount_in_portal_currency',
              references: {
                'USD|28750': {
                  id: 'USD|28750',
                  label: '$28,750.00'
                },
                'USD|14280': {
                  id: 'USD|14280',
                  label: '$14,280.00'
                },
                'USD|16340': {
                  id: 'USD|16340',
                  label: '$16,340.00'
                },
                'USD|7875': {
                  id: 'USD|7875',
                  label: '$7,875.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            one_time_or_initial: '#cbd6e2',
            recurring: '#99acc2'
          },
          field: 'hs_payment_type'
        },
        x: {
          type: 'linear',
          field: 'SUM|hs_initial_amount_in_portal_currency',
          blend: 'left'
        },
        dataset: 'primary',
        y: {
          type: 'category',
          field: 'hs_initiated_date',
          blend: 'bottom'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          left: {}
        },
        y: {
          bottom: {}
        },
        dateResolution: 'MONTH',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.total-payment-volume': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            hs_initiated_date: '2021-08-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 12574.97
          }, {
            hs_initiated_date: '2021-09-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 15680.25
          }, {
            hs_initiated_date: '2021-10-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 22214.98
          }, {
            hs_initiated_date: '2021-11-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 18114.99
          }, {
            hs_initiated_date: '2021-12-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 19474.99
          }, {
            hs_initiated_date: '2022-01-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 13614.99
          }, {
            hs_initiated_date: '2022-02-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 25624.99
          }, {
            hs_initiated_date: '2022-03-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 32574.99
          }, {
            hs_initiated_date: '2022-04-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 16014.99
          }, {
            hs_initiated_date: '2022-05-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 23754.99
          }, {
            hs_initiated_date: '2022-06-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 19344.99
          }, {
            hs_initiated_date: '2022-07-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 19384.99
          }, {
            hs_initiated_date: '2022-08-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 15349.99
          }, {
            hs_initiated_date: '2022-09-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 11709.99
          }, {
            hs_initiated_date: '2022-10-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 13987.59
          }, {
            hs_initiated_date: '2022-11-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 14599.99
          }, {
            hs_initiated_date: '2022-12-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 13679.99
          }, {
            hs_initiated_date: '2023-01-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 15892.39
          }, {
            hs_initiated_date: '2023-02-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 13865.99
          }, {
            hs_initiated_date: '2023-03-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 14915.99
          }, {
            hs_initiated_date: '2023-04-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 12347.99
          }, {
            hs_initiated_date: '2023-05-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 8970.99
          }, {
            hs_initiated_date: '2023-06-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 6071.99
          }, {
            hs_initiated_date: '2023-07-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 4650.99
          }, {
            hs_initiated_date: '2023-08-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 5670.99
          }, {
            hs_initiated_date: '2023-09-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 7670.99
          }, {
            hs_initiated_date: '2023-10-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 30670.99
          }, {
            hs_initiated_date: '2023-11-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 9400.99
          }, {
            hs_initiated_date: '2023-12-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 8364.99
          }, {
            hs_initiated_date: '2024-01-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 20364.99
          }, {
            hs_initiated_date: '2024-02-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 14342.0
          }, {
            hs_initiated_date: '2024-03-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 17439.65
          }, {
            hs_initiated_date: '2024-04-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 19489.0
          }, {
            hs_initiated_date: '2024-05-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 24889.0
          }, {
            hs_initiated_date: '2024-06-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 18244.0
          }, {
            hs_initiated_date: '2024-07-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 17294.0
          }, {
            hs_initiated_date: '2024-08-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 18294.0
          }, {
            hs_initiated_date: '2024-09-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 21294.0
          }, {
            hs_initiated_date: '2024-10-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 19494.0
          }, {
            hs_initiated_date: '2024-11-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 16472.0
          }, {
            hs_initiated_date: '2024-12-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 25911.15
          }, {
            hs_initiated_date: '2025-01-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 22616.0
          }, {
            hs_initiated_date: '2025-02-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 19316.0
          }, {
            hs_initiated_date: '2025-03-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 15816.0
          }, {
            hs_initiated_date: '2025-04-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 26460.0
          }, {
            hs_initiated_date: '2025-05-01',
            hs_currency_code: '@@MISSING@@',
            'SUM|hs_initial_amount': 18750.0
          }],
          properties: {
            hs_initiated_date: {
              format: {
                type: 'datetime',
                frequency: 'MONTH'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.paymentDate'),
              type: 'datetime',
              name: 'hs_initiated_date',
              references: {
                '2025-02-01': {
                  id: '2025-02-01',
                  label: 'Feb 2025'
                },
                '2024-12-01': {
                  id: '2024-12-01',
                  label: 'Dec 2024'
                },
                '2024-01-01': {
                  id: '2024-01-01',
                  label: 'Jan 2024'
                },
                '2023-11-01': {
                  id: '2023-11-01',
                  label: 'Nov 2023'
                },
                '2022-10-01': {
                  id: '2022-10-01',
                  label: 'Oct 2022'
                },
                '2025-01-01': {
                  id: '2025-01-01',
                  label: 'Jan 2025'
                },
                '2024-11-01': {
                  id: '2024-11-01',
                  label: 'Nov 2024'
                },
                '2023-10-01': {
                  id: '2023-10-01',
                  label: 'Oct 2023'
                },
                '2024-10-01': {
                  id: '2024-10-01',
                  label: 'Oct 2024'
                },
                '2021-09-01': {
                  id: '2021-09-01',
                  label: 'Sep 2021'
                },
                '2022-09-01': {
                  id: '2022-09-01',
                  label: 'Sep 2022'
                },
                '2021-08-01': {
                  id: '2021-08-01',
                  label: 'Aug 2021'
                },
                '2023-09-01': {
                  id: '2023-09-01',
                  label: 'Sep 2023'
                },
                '2022-08-01': {
                  id: '2022-08-01',
                  label: 'Aug 2022'
                },
                '2024-09-01': {
                  id: '2024-09-01',
                  label: 'Sep 2024'
                },
                '2023-08-01': {
                  id: '2023-08-01',
                  label: 'Aug 2023'
                },
                '2022-07-01': {
                  id: '2022-07-01',
                  label: 'Jul 2022'
                },
                '2024-08-01': {
                  id: '2024-08-01',
                  label: 'Aug 2024'
                },
                '2023-07-01': {
                  id: '2023-07-01',
                  label: 'Jul 2023'
                },
                '2022-06-01': {
                  id: '2022-06-01',
                  label: 'Jun 2022'
                },
                '2024-07-01': {
                  id: '2024-07-01',
                  label: 'Jul 2024'
                },
                '2023-06-01': {
                  id: '2023-06-01',
                  label: 'Jun 2023'
                },
                '2022-05-01': {
                  id: '2022-05-01',
                  label: 'May 2022'
                },
                '2024-06-01': {
                  id: '2024-06-01',
                  label: 'Jun 2024'
                },
                '2023-05-01': {
                  id: '2023-05-01',
                  label: 'May 2023'
                },
                '2022-04-01': {
                  id: '2022-04-01',
                  label: 'Apr 2022'
                },
                '2023-04-01': {
                  id: '2023-04-01',
                  label: 'Apr 2023'
                },
                '2022-03-01': {
                  id: '2022-03-01',
                  label: 'Mar 2022'
                },
                '2024-05-01': {
                  id: '2024-05-01',
                  label: 'May 2024'
                },
                '2022-02-01': {
                  id: '2022-02-01',
                  label: 'Feb 2022'
                },
                '2021-12-01': {
                  id: '2021-12-01',
                  label: 'Dec 2021'
                },
                '2025-05-01': {
                  id: '2025-05-01',
                  label: 'May 2025'
                },
                '2024-04-01': {
                  id: '2024-04-01',
                  label: 'Apr 2024'
                },
                '2023-03-01': {
                  id: '2023-03-01',
                  label: 'Mar 2023'
                },
                '2025-04-01': {
                  id: '2025-04-01',
                  label: 'Apr 2025'
                },
                '2024-03-01': {
                  id: '2024-03-01',
                  label: 'Mar 2024'
                },
                '2023-02-01': {
                  id: '2023-02-01',
                  label: 'Feb 2023'
                },
                '2022-12-01': {
                  id: '2022-12-01',
                  label: 'Dec 2022'
                },
                '2022-01-01': {
                  id: '2022-01-01',
                  label: 'Jan 2022'
                },
                '2021-11-01': {
                  id: '2021-11-01',
                  label: 'Nov 2021'
                },
                '2025-03-01': {
                  id: '2025-03-01',
                  label: 'Mar 2025'
                },
                '2024-02-01': {
                  id: '2024-02-01',
                  label: 'Feb 2024'
                },
                '2023-12-01': {
                  id: '2023-12-01',
                  label: 'Dec 2023'
                },
                '2023-01-01': {
                  id: '2023-01-01',
                  label: 'Jan 2023'
                },
                '2022-11-01': {
                  id: '2022-11-01',
                  label: 'Nov 2022'
                },
                '2021-10-01': {
                  id: '2021-10-01',
                  label: 'Oct 2021'
                }
              }
            },
            'SUM|hs_initial_amount': {
              format: {
                type: 'currency',
                currencyCodeColumnName: 'hs_currency_code',
                currencyCode: null
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumGrossAmount'),
              type: 'currency',
              name: 'hs_initial_amount',
              references: {
                '1342': {
                  id: '1342',
                  label: '1,342'
                },
                '3000': {
                  id: '3000',
                  label: '3,000'
                },
                '3816': {
                  id: '3816',
                  label: '3,816'
                },
                '10489': {
                  id: '10489',
                  label: '10,489'
                },
                '11316': {
                  id: '11316',
                  label: '11,316'
                },
                '13294': {
                  id: '13294',
                  label: '13,294'
                },
                '16472': {
                  id: '16472',
                  label: '16,472'
                },
                '16494': {
                  id: '16494',
                  label: '16,494'
                },
                '17616': {
                  id: '17616',
                  label: '17,616'
                },
                '18244': {
                  id: '18244',
                  label: '18,244'
                },
                '18294': {
                  id: '18294',
                  label: '18,294'
                },
                '36460': {
                  id: '36460',
                  label: '36,460'
                },
                '48000': {
                  id: '48000',
                  label: '48,000'
                },
                '49889': {
                  id: '49889',
                  label: '49,889'
                },
                '36364.99': {
                  id: '36364.99',
                  label: '36,364.99'
                },
                '16014.99': {
                  id: '16014.99',
                  label: '16,014.99'
                },
                '19344.99': {
                  id: '19344.99',
                  label: '19,344.99'
                },
                '19474.99': {
                  id: '19474.99',
                  label: '19,474.99'
                },
                '19384.99': {
                  id: '19384.99',
                  label: '19,384.99'
                },
                '15892.39': {
                  id: '15892.39',
                  label: '15,892.39'
                },
                '9439.65': {
                  id: '9439.65',
                  label: '9,439.65'
                },
                '2970.99': {
                  id: '2970.99',
                  label: '2,970.99'
                },
                '11709.99': {
                  id: '11709.99',
                  label: '11,709.99'
                },
                '256574.99': {
                  id: '256574.99',
                  label: '256,574.99'
                },
                '7347.99': {
                  id: '7347.99',
                  label: '7,347.99'
                },
                '74.97': {
                  id: '74.97',
                  label: '74.97'
                },
                '300670.99': {
                  id: '300670.99',
                  label: '300,670.99'
                },
                '14915.99': {
                  id: '14915.99',
                  label: '14,915.99'
                },
                '53624.99': {
                  id: '53624.99',
                  label: '53,624.99'
                },
                '1071.99': {
                  id: '1071.99',
                  label: '1,071.99'
                },
                '13614.99': {
                  id: '13614.99',
                  label: '13,614.99'
                },
                '31911.15': {
                  id: '31911.15',
                  label: '31,911.15'
                },
                '13679.99': {
                  id: '13679.99',
                  label: '13,679.99'
                },
                '13865.99': {
                  id: '13865.99',
                  label: '13,865.99'
                },
                '23754.99': {
                  id: '23754.99',
                  label: '23,754.99'
                },
                '15349.99': {
                  id: '15349.99',
                  label: '15,349.99'
                },
                '400.99': {
                  id: '400.99',
                  label: '400.99'
                },
                '37214.98': {
                  id: '37214.98',
                  label: '37,214.98'
                },
                '14599.99': {
                  id: '14599.99',
                  label: '14,599.99'
                },
                '13987.59': {
                  id: '13987.59',
                  label: '13,987.59'
                },
                '650.99': {
                  id: '650.99',
                  label: '650.99'
                },
                '14114.99': {
                  id: '14114.99',
                  label: '14,114.99'
                },
                '364.99': {
                  id: '364.99',
                  label: '364.99'
                },
                '670.99': {
                  id: '670.99',
                  label: '670.99'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            hs_currency_code: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: 'hs_currency_code',
              type: 'enumeration',
              name: 'hs_currency_code',
              references: {
                '@@MISSING@@': {
                  id: '@@MISSING@@',
                  label: '@@MISSING@@'
                }
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            'SUM|hs_initial_amount': '#fea58e'
          }
        },
        x: {
          type: 'category',
          field: 'hs_initiated_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|hs_initial_amount',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {}
        },
        dateResolution: 'MONTH',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.count-new-subscriptions': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            'SUM|count': 60,
            hs_recurring_billing_start_date: '2025-04-01'
          }, {
            'SUM|count': 130,
            hs_recurring_billing_start_date: '2025-05-01'
          }],
          properties: {
            hs_recurring_billing_start_date: {
              format: {
                type: 'date',
                frequency: 'MONTH'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.startDate'),
              type: 'date',
              name: 'hs_recurring_billing_start_date',
              references: {
                '2025-04-01': {
                  id: '2025-04-01',
                  label: 'Apr 2025'
                },
                '2025-05-01': {
                  id: '2025-05-01',
                  label: 'May 2025'
                }
              }
            },
            'SUM|count': {
              format: {
                type: 'number',
                isFormatted: true
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.countOfSubscriptions'),
              type: 'number',
              name: 'count',
              references: {
                '130': {
                  id: '130',
                  label: '130'
                },
                '60': {
                  id: '60',
                  label: '60'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            'SUM|count': '#fea58e'
          }
        },
        x: {
          type: 'category',
          field: 'hs_recurring_billing_start_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|count',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {}
        },
        dateResolution: 'MONTH',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.churn-subscriptions': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            'SUM|count': 1,
            hs_churn_date: '2021-08-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2021-09-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2021-10-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2021-11-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2021-12-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2022-01-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2022-02-01'
          }, {
            'SUM|count': 4,
            hs_churn_date: '2022-03-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2022-04-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2022-05-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2022-06-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2022-07-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2022-08-01'
          }, {
            'SUM|count': 3,
            hs_churn_date: '2022-09-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2022-10-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2022-11-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2022-12-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2023-01-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2023-02-01'
          }, {
            'SUM|count': 4,
            hs_churn_date: '2023-03-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2023-04-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2023-05-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2023-06-01'
          }, {
            'SUM|count': 1,
            hs_churn_date: '2023-07-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2023-08-01'
          }, {
            'SUM|count': 3,
            hs_churn_date: '2023-09-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2023-10-01'
          }, {
            'SUM|count': 3,
            hs_churn_date: '2023-11-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2023-12-01'
          }, {
            'SUM|count': 3,
            hs_churn_date: '2024-01-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2024-02-01'
          }, {
            'SUM|count': 3,
            hs_churn_date: '2024-03-01'
          }, {
            'SUM|count': 2,
            hs_churn_date: '2024-04-01'
          }, {
            'SUM|count': 3,
            hs_churn_date: '2024-05-01'
          }, {
            'SUM|count': 5,
            hs_churn_date: '2024-06-01'
          }, {
            'SUM|count': 3,
            hs_churn_date: '2024-07-01'
          }, {
            'SUM|count': 4,
            hs_churn_date: '2024-08-01'
          }, {
            'SUM|count': 5,
            hs_churn_date: '2024-09-01'
          }, {
            'SUM|count': 8,
            hs_churn_date: '2024-10-01'
          }, {
            'SUM|count': 6,
            hs_churn_date: '2024-11-01'
          }, {
            'SUM|count': 11,
            hs_churn_date: '2024-12-01'
          }, {
            'SUM|count': 7,
            hs_churn_date: '2025-01-01'
          }, {
            'SUM|count': 5,
            hs_churn_date: '2025-02-01'
          }, {
            'SUM|count': 12,
            hs_churn_date: '2025-03-01'
          }, {
            'SUM|count': 6,
            hs_churn_date: '2025-04-01'
          }, {
            'SUM|count': 4,
            hs_churn_date: '2025-05-01'
          }],
          properties: {
            hs_churn_date: {
              format: {
                type: 'date',
                frequency: 'MONTH'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.churnDate'),
              type: 'date',
              name: 'hs_churn_date',
              references: {
                '2025-02-01': {
                  id: '2025-02-01',
                  label: 'Feb 2025'
                },
                '2024-12-01': {
                  id: '2024-12-01',
                  label: 'Dec 2024'
                },
                '2024-01-01': {
                  id: '2024-01-01',
                  label: 'Jan 2024'
                },
                '2023-11-01': {
                  id: '2023-11-01',
                  label: 'Nov 2023'
                },
                '2022-10-01': {
                  id: '2022-10-01',
                  label: 'Oct 2022'
                },
                '2025-01-01': {
                  id: '2025-01-01',
                  label: 'Jan 2025'
                },
                '2024-11-01': {
                  id: '2024-11-01',
                  label: 'Nov 2024'
                },
                '2023-10-01': {
                  id: '2023-10-01',
                  label: 'Oct 2023'
                },
                '2024-10-01': {
                  id: '2024-10-01',
                  label: 'Oct 2024'
                },
                '2021-09-01': {
                  id: '2021-09-01',
                  label: 'Sep 2021'
                },
                '2022-09-01': {
                  id: '2022-09-01',
                  label: 'Sep 2022'
                },
                '2021-08-01': {
                  id: '2021-08-01',
                  label: 'Aug 2021'
                },
                '2023-09-01': {
                  id: '2023-09-01',
                  label: 'Sep 2023'
                },
                '2022-08-01': {
                  id: '2022-08-01',
                  label: 'Aug 2022'
                },
                '2024-09-01': {
                  id: '2024-09-01',
                  label: 'Sep 2024'
                },
                '2023-08-01': {
                  id: '2023-08-01',
                  label: 'Aug 2023'
                },
                '2022-07-01': {
                  id: '2022-07-01',
                  label: 'Jul 2022'
                },
                '2024-08-01': {
                  id: '2024-08-01',
                  label: 'Aug 2024'
                },
                '2023-07-01': {
                  id: '2023-07-01',
                  label: 'Jul 2023'
                },
                '2022-06-01': {
                  id: '2022-06-01',
                  label: 'Jun 2022'
                },
                '2024-07-01': {
                  id: '2024-07-01',
                  label: 'Jul 2024'
                },
                '2023-06-01': {
                  id: '2023-06-01',
                  label: 'Jun 2023'
                },
                '2022-05-01': {
                  id: '2022-05-01',
                  label: 'May 2022'
                },
                '2024-06-01': {
                  id: '2024-06-01',
                  label: 'Jun 2024'
                },
                '2023-05-01': {
                  id: '2023-05-01',
                  label: 'May 2023'
                },
                '2022-04-01': {
                  id: '2022-04-01',
                  label: 'Apr 2022'
                },
                '2023-04-01': {
                  id: '2023-04-01',
                  label: 'Apr 2023'
                },
                '2022-03-01': {
                  id: '2022-03-01',
                  label: 'Mar 2022'
                },
                '2024-05-01': {
                  id: '2024-05-01',
                  label: 'May 2024'
                },
                '2022-02-01': {
                  id: '2022-02-01',
                  label: 'Feb 2022'
                },
                '2021-12-01': {
                  id: '2021-12-01',
                  label: 'Dec 2021'
                },
                '2025-05-01': {
                  id: '2025-05-01',
                  label: 'May 2025'
                },
                '2024-04-01': {
                  id: '2024-04-01',
                  label: 'Apr 2024'
                },
                '2023-03-01': {
                  id: '2023-03-01',
                  label: 'Mar 2023'
                },
                '2025-04-01': {
                  id: '2025-04-01',
                  label: 'Apr 2025'
                },
                '2024-03-01': {
                  id: '2024-03-01',
                  label: 'Mar 2024'
                },
                '2023-02-01': {
                  id: '2023-02-01',
                  label: 'Feb 2023'
                },
                '2022-12-01': {
                  id: '2022-12-01',
                  label: 'Dec 2022'
                },
                '2022-01-01': {
                  id: '2022-01-01',
                  label: 'Jan 2022'
                },
                '2021-11-01': {
                  id: '2021-11-01',
                  label: 'Nov 2021'
                },
                '2025-03-01': {
                  id: '2025-03-01',
                  label: 'Mar 2025'
                },
                '2024-02-01': {
                  id: '2024-02-01',
                  label: 'Feb 2024'
                },
                '2023-12-01': {
                  id: '2023-12-01',
                  label: 'Dec 2023'
                },
                '2023-01-01': {
                  id: '2023-01-01',
                  label: 'Jan 2023'
                },
                '2022-11-01': {
                  id: '2022-11-01',
                  label: 'Nov 2022'
                },
                '2021-10-01': {
                  id: '2021-10-01',
                  label: 'Oct 2021'
                }
              }
            },
            'SUM|count': {
              format: {
                type: 'number',
                isFormatted: true
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.countOfSubscriptions'),
              type: 'number',
              name: 'count',
              references: {
                '0': {
                  id: '0',
                  label: '0'
                },
                '1': {
                  id: '1',
                  label: '1'
                },
                '2': {
                  id: '2',
                  label: '2'
                },
                '3': {
                  id: '3',
                  label: '3'
                },
                '4': {
                  id: '4',
                  label: '4'
                },
                '5': {
                  id: '5',
                  label: '5'
                },
                '9': {
                  id: '9',
                  label: '9'
                },
                '11': {
                  id: '11',
                  label: '11'
                },
                '54': {
                  id: '54',
                  label: '54'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            'SUM|count': '#fea58e'
          }
        },
        x: {
          type: 'category',
          field: 'hs_churn_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|count',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {}
        },
        dateResolution: 'MONTH',
        type: 'bar'
      },
      events: {}
    }),
    'commerce-analytics.count-churn-subscriptions': fromJS({
      type: 'XY',
      data: {
        primary: {
          data: [{
            'SUM|hs_arr_in_company_currency': 24000,
            __home_currency_code__: 'USD',
            'SUM|hs_mrr_in_company_currency': 2000,
            hs_churn_date: '2025-03-31'
          }, {
            'SUM|hs_arr_in_company_currency': 8640,
            __home_currency_code__: 'USD',
            'SUM|hs_mrr_in_company_currency': 720,
            hs_churn_date: '2025-04-07'
          }, {
            'SUM|hs_arr_in_company_currency': 2796,
            __home_currency_code__: 'USD',
            'SUM|hs_mrr_in_company_currency': 233,
            hs_churn_date: '2025-04-14'
          }, {
            'SUM|hs_arr_in_company_currency': 5160,
            __home_currency_code__: 'USD',
            'SUM|hs_mrr_in_company_currency': 430,
            hs_churn_date: '2025-04-21'
          }, {
            'SUM|hs_arr_in_company_currency': 3840,
            __home_currency_code__: 'USD',
            'SUM|hs_mrr_in_company_currency': 320,
            hs_churn_date: '2025-04-28'
          }, {
            'SUM|hs_arr_in_company_currency': 1920,
            __home_currency_code__: 'USD',
            'SUM|hs_mrr_in_company_currency': 160,
            hs_churn_date: '2025-05-05'
          }],
          properties: {
            hs_churn_date: {
              format: {
                type: 'date',
                frequency: 'WEEK'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.churnDate'),
              type: 'date',
              name: 'hs_churn_date',
              references: {
                '2025-03-31': {
                  id: '2025-03-31',
                  label: '3/31/2025'
                },
                '2025-04-07': {
                  id: '2025-04-07',
                  label: '4/7/2025'
                },
                '2025-04-14': {
                  id: '2025-04-14',
                  label: '4/14/2025'
                },
                '2025-04-21': {
                  id: '2025-04-21',
                  label: '4/21/2025'
                },
                '2025-04-28': {
                  id: '2025-04-28',
                  label: '4/28/2025'
                },
                '2025-05-05': {
                  id: '2025-05-05',
                  label: '5/5/2025'
                }
              }
            },
            'SUM|hs_arr_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumAnnualRecurringRevenueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_arr_in_company_currency',
              references: {
                'USD|24000': {
                  id: 'USD|24000',
                  label: '$24,000.00'
                },
                'USD|8640': {
                  id: 'USD|8640',
                  label: '$8,640.00'
                },
                'USD|2796': {
                  id: 'USD|2796',
                  label: '$2,796.00'
                },
                'USD|5160': {
                  id: 'USD|5160',
                  label: '$5,160.00'
                },
                'USD|3840': {
                  id: 'USD|3840',
                  label: '$3,840.00'
                },
                'USD|1920': {
                  id: 'USD|1920',
                  label: '$1,920.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            },
            __home_currency_code__: {
              format: {
                type: 'enumeration',
                referenceMeta: {
                  referenceType: 'CURRENCY_CODE'
                }
              },
              label: '__home_currency_code__',
              type: 'enumeration',
              name: '__home_currency_code__',
              references: {
                USD: {
                  id: 'USD',
                  label: 'US dollars (USD)'
                }
              }
            },
            'SUM|hs_mrr_in_company_currency': {
              format: {
                type: 'currency',
                currencyCodeColumnName: '__home_currency_code__',
                companyCurrencyCode: 'USD',
                currencyCode: 'USD'
              },
              label: text('reporting-enablement.zeroStatePreview.sampleDataLabels.sumMonthlyRecurringRevenueInCompanyCurrency'),
              type: 'currency',
              name: 'hs_mrr_in_company_currency',
              references: {
                'USD|2000': {
                  id: 'USD|2000',
                  label: '$2,000.00'
                },
                'USD|720': {
                  id: 'USD|720',
                  label: '$720.00'
                },
                'USD|233': {
                  id: 'USD|233',
                  label: '$233.00'
                },
                'USD|430': {
                  id: 'USD|430',
                  label: '$430.00'
                },
                'USD|320': {
                  id: 'USD|320',
                  label: '$320.00'
                },
                'USD|160': {
                  id: 'USD|160',
                  label: '$160.00'
                }
              },
              propertyMeta: {
                aggregationType: 'SUM'
              }
            }
          }
        },
        compare: {
          data: [],
          properties: {}
        }
      },
      layers: [{
        color: {
          defined: {
            'SUM|hs_arr_in_company_currency': '#fea58e',
            'SUM|hs_mrr_in_company_currency': '#51d3d9'
          }
        },
        x: {
          type: 'category',
          field: 'hs_churn_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|hs_arr_in_company_currency',
          blend: 'left'
        }
      }, {
        color: {
          defined: {
            'SUM|hs_arr_in_company_currency': '#fea58e',
            'SUM|hs_mrr_in_company_currency': '#51d3d9'
          }
        },
        x: {
          type: 'category',
          field: 'hs_churn_date',
          blend: 'bottom'
        },
        dataset: 'primary',
        y: {
          type: 'linear',
          field: 'SUM|hs_mrr_in_company_currency',
          blend: 'left'
        }
      }],
      style: {
        dataLabels: true,
        showLegend: true,
        isMobile: false,
        colors: ['#cbd6e2', '#99acc2'],
        x: {
          bottom: {}
        },
        y: {
          left: {
            title: ''
          }
        },
        dateResolution: 'WEEK',
        type: 'bar'
      },
      events: {}
    })
  };
  return sampleChartVisualizationsByTemplateKey[templateKey];
};